import type { Components } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";

import type { Theme } from "../types";

export const MuiMenu = {
  styleOverrides: {
    paper: {
      borderRadius: 12,
      marginTop: 6,
      minWidth: 180,
      border: "1px solid #ECEFF3",
      boxShadow:
        "0 10px 30px rgba(16,24,40,0.10), 0 2px 6px rgba(16,24,40,0.06)",
    },
    list: {
      padding: 6,
    },
  },
} satisfies Components<Theme>["MuiMenu"];

export const MuiMenuItem = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 8,
      fontSize: "0.875rem",
      padding: "8px 12px",
      margin: "1px 0",
      transition: "background-color 120ms ease",
      "&:hover": { backgroundColor: theme.palette.background.level2 },
      "&.Mui-selected": {
        backgroundColor: `${theme.palette.primary.main}14`,
        "&:hover": { backgroundColor: `${theme.palette.primary.main}1f` },
      },
    }),
  },
} satisfies Components<Theme>["MuiMenuItem"];

export const MuiDialog = {
  styleOverrides: {
    paper: {
      borderRadius: 16,
      boxShadow: "0 24px 60px rgba(16,24,40,0.18)",
    },
  },
} satisfies Components<Theme>["MuiDialog"];

export const MuiDialogTitle = {
  styleOverrides: {
    root: {
      fontSize: "1.1rem",
      fontWeight: 800,
      padding: "20px 24px 12px",
    },
  },
} satisfies Components<Theme>["MuiDialogTitle"];

export const MuiChip = {
  styleOverrides: {
    root: {
      borderRadius: 8,
      fontWeight: 600,
    },
    sizeSmall: {
      height: 22,
      fontSize: "0.72rem",
    },
    label: {
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
} satisfies Components<Theme>["MuiChip"];

export const MuiTableRow = {
  styleOverrides: {
    root: ({ theme }) => ({
      transition: "background-color 120ms ease",
      "&:hover": {
        backgroundColor: theme.palette.background.level1,
      },
      [`&:last-of-type .${tableCellClasses.root}`]: {
        borderBottom: "none",
      },
    }),
  },
} satisfies Components<Theme>["MuiTableRow"];
